import {Component, computed, input} from '@angular/core';
import {NgForOf, NgSwitch, NgSwitchCase} from "@angular/common";
import {Card, CardType} from "./model/scorecard-model";
import {CourseCardComponent} from "./card/course/course-card.component";
import {ParticipantCardComponent} from "./card/participant/participant-card.component";
import {GroupCardComponent} from "./card/group/group-card.component";
import {TeamCardComponent} from "./card/team/team-card.component";
import {Scorecard} from "../model/round";

@Component({
    selector: 'app-scorecard',
    templateUrl: './scorecard.component.html',
    imports: [
        NgForOf,
        NgSwitch,
        NgSwitchCase,
        CourseCardComponent,
        ParticipantCardComponent,
        GroupCardComponent,
        TeamCardComponent
    ],
    styleUrls: ['./scorecard.component.css']
})
export class ScorecardComponent {
    readonly scorecard = input.required<Scorecard>();

    readonly cards = computed(() => {
        return this.scorecard().cards
    });

    trackByCardType(_: number, card: Card) {
        return card.type;
    }

    protected readonly CardType = CardType;
}